// @ts-nocheck
import { CSSProperties, ReactNode, createElement } from "react";
import clsx from "clsx";

export type TextProps = {
  as?: "h1" | "h2" | "h3" | "h4" | "h5" | "p" | "span" | "li";
  type?:
    | "heading"
    | "headline1"
    | "headline2"
    | "headline3"
    | "subtitle1"
    | "subtitle2"
    | "body1"
    | "body2"
    | "caption"
    | "inherit"
    | "button1"
    | "button2";
  weight?: "100" | "200" | "300" | "400" | "500" | "600" | "700" | "inherit";
  // color?:
  //   | "primary"
  //   | "secondary"
  //   | "success"
  //   | "error"
  //   | "warning"
  //   | "inherit"
  //   | "white";
  bold?: boolean;
  className?: string;
  firstCapitalize?: boolean;
  children: ReactNode;
  style?: CSSProperties;
  medium?: boolean;
  inherit?: boolean;
};

const types: Record<Required<TextProps>["type"], string> = {
  body1: "Body1",
  body2: "Body2",
  caption: "Caption",
  heading: "Heading",
  headline1: "Headline1",
  headline2: "Headline2",
  headline3: "Headline3",
  subtitle1: "Subtitle1",
  subtitle2: "Subtitle2",
  button1: "Button1",
  button2: "Button2",
  inherit: "", // TODO make it better
};

const weights: Record<Required<TextProps>["weight"], string> = {
  "100": "font-thin",
  "200": "font-extralight",
  "300": "font-light",
  "400": "font-normal",
  "500": "font-medium",
  "600": "font-semibold",
  "700": "font-bold",
  inherit: "font-inherit",
};

// const colors: Record<Required<TextProps>["color"], string> = {
//   primary: "#05213B",
//   secondary: "#94A9BD",
//   error: "#E94F54",
//   success: "#2D912D",
//   warning: "#B68C14",
//   inherit: "inherit",
//   white: "white",
// };

export const Text = ({
  as = "p",
  type = "body1",
  weight = "400",
  bold,
  children,
  // color = "primary",
  className,
  firstCapitalize,
  style,
  medium,
  inherit,
  ...rest
}: TextProps) => {
  return createElement(
    as,
    {
      style: {
        // color: inherit ? colors.inherit : colors[color],

        ...style,
      },
      className: clsx(
        className,
        "text-" + types[type],
        weights[weight],
        bold && weight["700"],
        firstCapitalize && "first-letter:uppercase",
        medium && "font-medium",
        inherit && clsx(types.inherit, weights.inherit),
      ),
      ...rest,
    },
    children,
  );
};
